import React from 'react';
import PropTypes from 'prop-types';
import Snackbar from '@material-ui/core/Snackbar';
import IconButton from '@material-ui/core/IconButton';
import CancelIcon from '@material-ui/icons/Cancel';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import CheckCircleOutlinedIcon from '@material-ui/icons/CheckCircleOutlined';
import '../../../css/core/components/MessageSnackbar.scss';

class MessageSnackbar extends React.Component {
  state = {
    open: this.props.openMessageSnackbar,
  };

  componentDidUpdate(prevProps) {
    const { openMessageSnackbar, errorMsg, successMsg } = this.props;

    const isMsgDiff = (prevProps.errorMsg !== errorMsg) || (prevProps.successMsg !== successMsg);
    const isOpenDiff = openMessageSnackbar !== prevProps.openMessageSnackbar;

    if (isOpenDiff || isMsgDiff) {
      this.setState({
        open: openMessageSnackbar,
      });
    }
  }

  getSnackBarContentClasses = () => {
    const isErrorOrSuccess = this.isErrorOrSuccess();
    if (!isErrorOrSuccess) return {};

    // TO-DO: remove inline styles
    const snackBarContentRoot = {
      display: 'flex',
      'flex-wrap': 'nowrap',
    };
    const successSnackBarContentRoot = {
      ...snackBarContentRoot,
      'background-color': '#4caf50',
    };

    const errorSnackBarContentRoot = {
      ...snackBarContentRoot,
      'background-color': '#f44336',
    };
    return {
      root: isErrorOrSuccess === 'error' ? errorSnackBarContentRoot : successSnackBarContentRoot,
      action: {
        'padding-left': '5px',
      },
    };
  }

  getErrorOrSuccessIcon = (isErrorOrSuccess) => {
    const { translation } = this.props;
    if (!isErrorOrSuccess) return null;
    const warningIcon = (
      <ErrorOutlineIcon
        aria-label={translation('MessageSnackbar.warningIconAriaLabel')}
      />
    );
    const successIcon = (
      <CheckCircleOutlinedIcon
        aria-label={translation('MessageSnackbar.successIconAriaLabel')}
      />
    );
    return isErrorOrSuccess === 'error' ? warningIcon : successIcon;
  }

  handleClose = () => {
    const { actions } = this.props;
    this.setState({ open: false });
    actions.clearMessage();
  };

  isErrorOrSuccess = () => {
    const { errorMsg, successMsg } = this.props;
    if (errorMsg) return 'error';
    if (successMsg) return 'success';
    return null;
  }

  renderIconAndMessage = () => {
    const { errorMsg, successMsg } = this.props;
    const isErrorOrSuccess = this.isErrorOrSuccess();
    return (
      <div className="messageSnackbar-iconAndMessageContainer">
        <div className="messageSnackbar-iconContainer">
          {this.getErrorOrSuccessIcon(isErrorOrSuccess)}
        </div>
        <div className="messageSnackbar-messageContainer">
          <span id="message-id">
            {errorMsg || successMsg}
          </span>
        </div>
      </div>
    );
  }

  render() {
    return (
      <Snackbar
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        open={this.state.open}
        autoHideDuration={null}
        onClose={this.handleClose}
        ContentProps={{
          'aria-describedby': 'message-id',
          style: this.getSnackBarContentClasses(),
        }}
        message={this.renderIconAndMessage()}
        action={[
          <IconButton
            key="close"
            aria-label="close"
            color="inherit"
            className="messageSnackbar-iconButton"
            onClick={this.handleClose}
          >
            <CancelIcon />
          </IconButton>,
        ]}
      />
    );
  }
}

MessageSnackbar.propTypes = {
  actions: PropTypes.object.isRequired,
  openMessageSnackbar: PropTypes.bool.isRequired,
  errorMsg: PropTypes.string,
  successMsg: PropTypes.string,
  translation: PropTypes.func.isRequired,
};

MessageSnackbar.defaultProps = {
  errorMsg: '',
  successMsg: '',
};

export default MessageSnackbar;
